import { useMemo } from 'react';
import {
  U21Alert,
  U21Chip,
  U21Table,
  U21TableColumn,
} from 'app/shared/u21-ui/components';
import {
  ConsortiumAlertV2,
  INVESTIGATION_OUTCOME_DISPLAY,
  InvestigationOutcome,
} from 'app/modules/consortium/responsesV2';

type ConsortiumAlertV2Row = ConsortiumAlertV2 & {
  investigation_outcome: InvestigationOutcome;
};

const COLUMNS: U21TableColumn<ConsortiumAlertV2Row, any>[] = [
  {
    id: 'investigation_outcome',
    Header: 'Investigation outcome',
    accessor: (row) => {
      const display = INVESTIGATION_OUTCOME_DISPLAY[row.investigation_outcome];
      return (
        <U21Chip color={display.color} variant={display.variant}>
          {display.label}
        </U21Chip>
      );
    },
  },
  {
    id: 'activity_categories',
    Header: 'Activity categories',
    accessor: 'activity_categories',
    type: 'list',
  },
  {
    id: 'org_type',
    Header: 'Org type',
    accessor: 'org_type',
    type: 'text',
  },
  {
    id: 'created_at',
    Header: 'Created at',
    accessor: 'created_at',
    type: 'datetime',
  },
  {
    id: 'dispositioned_at',
    Header: 'Dispositioned at',
    accessor: 'dispositioned_at',
    type: 'datetime',
  },
  {
    id: 'last_touched_at',
    Header: 'Updated at',
    accessor: 'last_touched_at',
    type: 'datetime',
  },
];

interface Props {
  alerts: ConsortiumAlertV2[];
  hasMore: boolean;
  loading?: boolean;
}

export const ConsortiumAlertsV2Table = ({
  alerts,
  hasMore,
  loading,
}: Props) => {
  const rows = useMemo<ConsortiumAlertV2Row[]>(
    () =>
      alerts.filter(
        (alert): alert is ConsortiumAlertV2Row =>
          alert.investigation_outcome !== null,
      ),
    [alerts],
  );

  return (
    <>
      {hasMore && (
        <U21Alert color="info">
          Only the first 20 alerts are shown. There are more alerts in the
          consortium for this entity.
        </U21Alert>
      )}
      <U21Table
        columns={COLUMNS}
        data={rows}
        label="consortium alert"
        loading={loading}
      />
    </>
  );
};
